import UserAgentCheck from "../util/UserAgentCheck";
import Cookies from "js-cookie";
export class ConsentData {
    constructor(analyticsStatus, personalStatus, marketingStatus) {
        this.analyticsStatus = analyticsStatus;
        this.personalStatus = personalStatus;
        this.marketingStatus = marketingStatus;
    }
    getPersonalStatus() {
        return this.personalStatus || false;
    }
    getMarketingStatus() {
        return this.marketingStatus || false;
    }
}
export class Consent {
    static isConsentBannerVisible() {
        let consentBannerDiv = document.getElementById("JOISH987_bar_holder");
        if (consentBannerDiv) {
            let display = consentBannerDiv.style.display;
            return "block" === display;
        }
        return false;
    }

    static isConsentModalVisible() {
        let consentBannerDiv = document.getElementById("JOISH987_box");
        return !!consentBannerDiv;

    }
}
//# sourceMappingURL=Consent.js.map